import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import classnames from 'classnames'
import useClickAway from '../../hooks/useClickAway'
import {
  blacklistTag,
  unblacklistTag,
  unwhitelistTag,
  whitelistTag,
  blacklistCategory,
  unblacklistCategory,
  unwhitelistCategory,
  whitelistCategory,
} from '../../user/userActions'
import WhitelistToggle from './WhitelistToggle'
import BlacklistToggle from './BlacklistToggle'

const ListOptions = ({
  tag,
  isCategory,
  dispatch,
  isWhitelisted,
  isBlacklisted,
}) => {

  const [showActions, setShowActions] = useState(false)
  const listOptionsRef = useRef(null)

  useClickAway(listOptionsRef, () => {
    if (showActions) setShowActions(false)
  })

  const handleToggleActions = () => {
    setShowActions(prev => !prev)
  }

  const handleActionClick = (action) => {
    dispatch(action(tag.id))
    setShowActions(false)
  }

  // Still loading data
  if (!tag) {
    return null
  }

  const name = isCategory ? tag.name : '#' + tag.name
  return (
    <div className='list-options' ref={ listOptionsRef }>
      <button
        type='button'
        className={ classnames('list-options-toggle', {'list-options-toggle__whitelisted': isWhitelisted}, {'list-options-toggle__blacklisted': isBlacklisted} ) }
        onClick={ handleToggleActions }
        aria-label='Avaa listan toimintavalikko '
      >
        <i className='fa fa-ellipsis-v' aria-hidden='true' />
        <span className={ classnames({'fa fa-check-circle-o': isWhitelisted}, {'fa fa-times-circle-o': isBlacklisted} ) } />
      </button>

      { showActions &&
      <div className='category-switch__menu-container'>
        <WhitelistToggle
          isWhitelisted={ isWhitelisted }
          onWhitelist={ () => handleActionClick(isCategory ? whitelistCategory : whitelistTag) }
          onUnwhitelist={ () => handleActionClick(isCategory ? unwhitelistCategory : unwhitelistTag) }
          name={ name }
        />
        <BlacklistToggle
          isBlacklisted={ isBlacklisted }
          onBlacklist={ () => handleActionClick(isCategory ? blacklistCategory : blacklistTag) }
          onUnblacklist={ () => handleActionClick(isCategory ? unblacklistCategory : unblacklistTag) }
          name={ name }
        />
      </div>
      }

    </div>
  )
}

ListOptions.propTypes = exact({
  tag: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    h1: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    type: PropTypes.string,
    blacklisted: PropTypes.bool,
    whitelisted: PropTypes.bool,
    breaking: PropTypes.bool,
  }),
  isCategory: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  isWhitelisted: PropTypes.bool.isRequired,
  isBlacklisted: PropTypes.bool.isRequired,
})

export default (ListOptions)
